function changeAction(event) {
  const wrapper = event.currentTarget.parentElement;
  const selector = event.currentTarget.dataset.panel;

  if (!event.currentTarget.classList.contains('is-active')
  && (selector && document.getElementsByClassName(selector).length)) {
    wrapper.querySelectorAll('.ac-tab').forEach((tab) => {
      tab.classList.remove('is-active');
      if (tab.dataset.panel) {
        if (document.getElementsByClassName(tab.dataset.panel).length) {
          document.getElementsByClassName(tab.dataset.panel)[0].classList.add(tab.dataset.class ? tab.dataset.class : 'hide');
        }
      }
    });

    event.currentTarget.classList.add('is-active');
    document.getElementsByClassName(selector)[0].classList.remove(event.currentTarget.dataset.class
      ? event.currentTarget.dataset.class : 'hide');
  }
}

function init() {
  document.querySelectorAll('.ac-tab').forEach((elm) => elm.addEventListener('click', changeAction));
}

export default init;
